export default [
  {
    title: 'Inicio',
    icon: 'home',
    path: '/'
  },
];
